
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/courses/learn-javascript-for-kids-and-teens",
      function () {
        return require("private-next-pages/courses/learn-javascript-for-kids-and-teens.tsx");
      }
    ]);
  